import React from "react";
import { Link } from "react-router-dom";
import { getAllFood, deleteFood } from "../api/food";
import { toast } from "react-toastify";
import { getUnit, getYesNo } from "../misc/utils";

class FoodDB extends React.Component {
    state = {
        foodList: []
    };

    async componentDidMount() {
        // This binding is necessary to make `this` work in the callback
        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        await this.getFoodList();
    }

    async getFoodList() {
        let food = await getAllFood();

        this.setState({
            foodList: food
        });
    }

    displayPortion(portion, unitId) {
        return `${portion} ${getUnit(unitId)}`;
    }

    async onDeleteClicked(foodId) {
        try {
            if (window.confirm("Estas seguro?")) {
                await deleteFood(foodId);

                var array = [...this.state.foodList]; // make a separate copy of the array
                var index = array.findIndex(f => f.id === foodId);
                if (index !== -1) {
                    array.splice(index, 1);
                    this.setState({ foodList: array });
                    toast.success("Alimento borrado exitosamente");
                }
            }
        } catch {
            toast.error("Hubo un error al borrar el alimento");
        }
    }

    render() {
        return (
            <>
                <h2> Food Database </h2>
                <Link to="/Food" className="btn btn-primary">
                    Agregar Alimento
                </Link>
                <br />
                <br />
                <form>
                    <table className="table table-sm">
                        <thead className="table-dark">
                            <tr>
                                <th>Name</th>
                                <th>Portion</th>
                                <th>Calories</th>
                                <th>Carbs</th>
                                <th>Proteins</th>
                                <th>Fats</th>
                                <th>AutoDiet</th>
                                <th>MinPortion</th>
                                <th>MaxPortion</th>
                                <th />
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.foodList.map(food => {
                                return (
                                    <tr key={food.id}>
                                        <td>{food.name}</td>
                                        <td>
                                            {this.displayPortion(food.portion, food.portionUnit)}
                                        </td>
                                        <td>{food.calories}</td>
                                        <td>{food.carbs}</td>
                                        <td>{food.proteins}</td>
                                        <td>{food.fats}</td>
                                        <td>{getYesNo(food.autoDiet)}</td>
                                        <td>
                                            {this.displayPortion(food.minPortion, food.portionUnit)}
                                        </td>
                                        <td>
                                            {this.displayPortion(food.maxPortion, food.portionUnit)}
                                        </td>
                                        <td>
                                            <Link
                                                to={`/food/${food.id}`}
                                                className="btn btn-primary btn-sm"
                                            >
                                                Editar
                                            </Link>
                                        </td>
                                        <td>
                                            <input
                                                type="button"
                                                onClick={event => this.onDeleteClicked(food.id)}
                                                className="btn btn-danger btn-sm"
                                                value="Borrar"
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </form>
            </>
        );
    }
}
export default FoodDB;
